import { DataService } from './dataService'

const masterServices = {

    // Dashboard
    get_dashabord: async () => {
        return DataService.get('/admin/get_dashboard')
    },


    // Warehouse

    add_warehouse: async (data) => {
        return DataService.post('/admin/add_warehouse', data)
    },

    update_warehouse: async (data) => {
        return DataService.post('/admin/update_warehouse', data)
    },

    update_warehouse_status: async (data) => {
        return DataService.post('/admin/update_warehouse_status', data)
    },

    delete_warehouse: async (data) => {
        return DataService.post('/admin/delete_warehouse', data)
    },

    get_warehouse: async (data) => {
        return DataService.get('/admin/get_warehouse', data)
    },

    get_warehouse_details: async (data) => {
        return DataService.get('/admin/get_warehouse_details', data)
    },

    // Storage

    // update_storage: async (data) => {
    //     return DataService.post('/admin/update_storage', data)
    // },

    get_storage: async (data) => {
        return DataService.get('/admin/get_storage', data)
    },
    add_storage: async (data) => {
        return DataService.post('/admin/add_storage', data)
    },


    //insurence

    update_insurance: async (data) => {
        return DataService.post('/admin/update_insurance', data)
    },

    get_insurance: async (data) => {
        return DataService.get('/admin/get_insurance', data)
    },
    add_insurance: async (data) => {
        return DataService.post('/admin/add_insurance', data)
    },
    get_insurance_details: async (data) => {
        return DataService.get('/admin/get_insurance_details?id=' + data.id)
    },


    //profit Margin

    add_profit_margin: async (data) => {
        return DataService.post('/admin/add_profit_margin_tarrif', data)
    },
    update_profit_margin: async (data) => {
        return DataService.post('/admin/update_profit_margin_tarrif', data)
    },

    delete_profit_margin: async (data) => {
        return DataService.post('/admin/delete_profit_margin_tarrif', data)
    },

    get_profit_margin: async (data) => {
        return DataService.get('/admin/get_profit_margin_tarrif', data)
    },
    // package master 

    get_package: async (data) => {
        return DataService.get('/admin/get_packing', data)
    },
    add_package: async (data) => {
        return DataService.post('/admin/add_packing', data)
    },

    // update_package: async (data) => {
    //     return DataService.post('/admin/add_packing', data)
    // },

    // Commercial master

    addCommercial: async (data) => {
        return DataService.post('/admin/add_commercials', data)
    },

    getCommercial: async (data) => {
        return DataService.get('/admin/get_commercials', data)
    },

    get_commercial_details: async (data) => {
        return DataService.get('/admin/get_commercials_details', data)
    },

    updateCommercial: async (data) => {
        return DataService.post('/admin/update_commercials', data)
    },

    // Commercial master

    add_corporate: async (data) => {
        return DataService.post('/admin/add_corporate', data)
    },

    get_corporate: async (data) => {
        return DataService.get('/admin/get_corporate', data)
    },

    get_corporate_details: async (data) => {
        return DataService.get('/admin/get_corporate_details', data)
    },

    update_corporate: async (data) => {
        return DataService.post('/admin/update_corporate', data)
    },
    update_corporate_status: async (data) => {
        return DataService.post('/admin/update_corporate_status', data)
    },

    /// upload document
    upload_document: async (data) => {
        return DataService.post('/admin/add_document', data)
    },

    upload_document: async (data) => {
        return DataService.post('/admin/add_document', data)
    },

    getMonthlyJobsData : async () => {
        return DataService.get('/admin/monthly_job_list')
    },

    getMonthlyPickupData : async () => {
        return DataService.get('/admin/pick_up_chart')
    },

    //marketplace

    get_marketplace: async (data) => {
        return DataService.get('/admin/marketplace_additional_charges', data)
    },

}

export default masterServices;